import { Injectable } from '@angular/core';
import { StoreConfig, EntityStore, EntityState } from '@datorama/akita';
import { PortalProductSubscription } from '../portal-products-subscriptions/models/portal-product-subscription.model';

export interface PortalProductsSubscriptionsState extends EntityState<PortalProductSubscription> {}

/**
 * This subscribed portal products
 * store will consist of entities which are
 * portal products that have been purchased
 * by a member.
 */

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'portal-products-subscriptions', idKey: 'SubscriptionId' })
export class PortalProductsSubscriptionsStore extends EntityStore<PortalProductsSubscriptionsState> {
  constructor() {
    super();
  }
}
